
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import * as Yup from 'yup';
import { AC_YEAR_OLD, ERROR_MSG } from '../../CommonUtils/contextVariables';
import { CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { digisignFunction } from '../../CommonUtils/DIGISIGN/digisignFunction';
import { showPDF } from '../../CommonUtils/DIGISIGN/convertFileToBase64';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { BackButton } from '../../CommonUtils/CommonServices';
export default function AfflOrderGenGovtDetails() {
    const location = useLocation();
    const acYear = sessionStorage.getItem('ac_year');
    const collegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const [viewpdf, setViewpdf] = useState('');
    const [hidepdf, setHidepdf] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    let pageName = location?.state?.type;

    const AfflOrderDetailsValidation = Yup.object({
        authorityBy: Yup.string().required(ERROR_MSG).nullable(),
        afflOrderProcNo202223: Yup.string().required(ERROR_MSG).nullable(),
        registrarRemarks: Yup.string().required(ERROR_MSG).nullable(),
        // universityEcDoc: Yup.string().required(ERROR_MSG).nullable(),
        // universityEcDate: Yup.string().required(ERROR_MSG).nullable(),
        gortNo: Yup.string().required(ERROR_MSG).nullable(),
        gortDate: Yup.string().required(ERROR_MSG).nullable(),
        // gortDate2: Yup.string().required(ERROR_MSG).nullable(),
        // gortNo2: Yup.string().required(ERROR_MSG).nullable(),
        // gortDate3: Yup.string().required(ERROR_MSG).nullable(),
        // gortNo3: Yup.string().required(ERROR_MSG).nullable(),

        // gortDate4: Yup.string().required(ERROR_MSG).nullable(),
        // gortNo4: Yup.string().required(ERROR_MSG).nullable(),
        afflOrderProcNo202021: Yup.string().required(ERROR_MSG).nullable(),
        afflOrder202021Date: Yup.string().required(ERROR_MSG).nullable(),
    })
    const [modal, setModal] = useState(false)
    const handleClose = () => {
        setModal(false);
        setPdfUrl('');
    };

    const afflOrderGenFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            collCode: collegeCode,
            acYear: acYear,
            gortNo: "",
            gortDate: "",
            finalPdfPath: "",
            afflOrder202021Date: "",
            afflOrderProcNo202021: "",
            gortNo2: "",
            universityEcDoc: "",
            gortNo3: "",
            gortNo4: "",
            gortDate2: "",
            gortDate3: "",
            gortDate4: "",
            afflOrder202223Date: "",
            afflOrderProcNo202223: "",
            universityEcDate: "",
            registrarRemarks: "",
            authorityBy: "",
            afflType: "",
            remarks: "",

        },
        validationSchema: AfflOrderDetailsValidation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAfflOrderGenerationGovt`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.Status === true) {
                            setHidepdf(true)
                            successAlert2(res?.data?.sdesc);
                            setViewpdf(res?.data?.path)
                        } else {
                            failureAlert("Failed to submit");
                        }
                    });
                }
            });
        }
    })

    async function dskConfirmationFunc() {
        if (viewpdf !== null && viewpdf !== undefined && viewpdf !== "") {
            try {
                let img = config.url.FILE_DOWNLOAD_URL + viewpdf
                const base64Data = await showPDF(img);
                const extractedData = base64Data;
                let postData = {
                    path: config.url.API_URL + "saveAfflOrderGovt",
                    params: {
                        collCode: collegeCode,
                        acYear: acYear,
                        // finalPdfPath: viewpdf,
                    }
                }
                digisignFunction(extractedData, "-1", postData, "", pageName);
            } catch (error) {
                console.error("Error:", error);
            }
        }
    }
    const showViewPDF = (imgg) => {
        ConvertFileToBase64(imgg).then(base64Data => {
            const extractedData = base64Data.split(',')[1];
            const binaryData = atob(extractedData);
            const arrayBuffer = new ArrayBuffer(binaryData.length);
            const uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData?.charCodeAt(i);
            }
            const blob = new Blob([uint8Array], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
            setModal(true);
        })
    };

    async function ConvertFileToBase64(fileUrl) {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader?.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        })
    }
    return (
        <>
            <CommonFormHeading heading={`Affiliation Order Details  ${acYear}`} />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <BackButton />
                <FormikProvider value={afflOrderGenFormik}>
                    <Form onChange={afflOrderGenFormik?.handleChange} onSubmit={afflOrderGenFormik?.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3">
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1' >Upload University EC Resolution Document:</label>
                                    <input type="file" name="universityEcDoc" className="form-control mb-2 mt-3" accept='application/pdf'
                                        onChange={(e) => {
                                            let filename = 'universityEcDoc';
                                            let path = "/Uploads/AffiliationOrder_2023/";
                                            ImagePdfBucket(e, afflOrderGenFormik, path, `universityEcDoc`, filename, "pdf");
                                        }}
                                    />
                                    {/* <ErrorMessage name="universityEcDoc" component="div" className="text-error" /> */}

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1'>Date of Latest EC Meeting :</label>
                                    <Field type='date' name="universityEcDate" className='form-control mb-2 mt-3' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    {/* <ErrorMessage name="universityEcDate" component="div" className="text-error" /> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={5} xxl={5} className='mb-2'>
                                    <label className='field-mandatory mb-1'>Reference Number of the Proceedings of CCE that stands as reference in the Affiliation Order {acYear}   :   1 </label>
                                    <Field type='text' name="gortNo" className='form-control mb-2' />
                                    <ErrorMessage name="gortNo" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='field-mandatory mb-1'>Date of Proceedings of CCE that stands as reference in the Affiliation Order {acYear}   :  1</label>
                                    <Field type='date' name="gortDate" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    <ErrorMessage name="gortDate" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1'>Reference Number of the Proceedings of Latest EC Meeting :2</label>
                                    <Field type='text' name="gortNo2" className='form-control mb-2' maxLength={80} />
                                    {/* <ErrorMessage name="gortNo2" component="div" className="text-error" /> */}

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1' >Date of Reference Number of the Proceedings of Latest EC Meeting :2</label>
                                    <Field type='date' name="gortDate2" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    {/* <ErrorMessage name="gortDate2" component="div" className="text-error" /> */}

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1'>Reference Number of the Proceedings/Order/Letter/Report :3</label>
                                    <Field type='text' name="gortNo3" className='form-control mb-2' maxLength={80} />
                                    {/* <ErrorMessage name="gortNo3" component="div" className="text-error" /> */}

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1'>Date of Reference Number of the Proceedings/Order/Letter/Report : 3</label>
                                    <Field type='date' name="gortDate3" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    {/* <ErrorMessage name="gortDate3" component="div" className="text-error" /> */}

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1' >Reference Number of the Proceedings/Order/Letter/Report :4</label>
                                    <Field type='text' name="gortNo4" className='form-control' maxLength={80} />
                                    {/* <ErrorMessage name="gortNo4" component="div" className="text-error" /> */}

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1'>Date of Reference Number of the Proceedings/Order/Letter/Report : 4</label>
                                    <Field type='date' name="gortDate4" className='form-control' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    {/* <ErrorMessage name="gortDate4" component="div" className="text-error" /> */}

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='field-mandatory mb-1' >Date of Affiliation Order {AC_YEAR_OLD}:</label>
                                    <Field type='date' name="afflOrder202021Date" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    <ErrorMessage name="afflOrder202021Date" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='field-mandatory mb-1'>Proceedings Number of Affiliation Order {AC_YEAR_OLD} </label>
                                    <Field type='text' name="afflOrderProcNo202021" className='form-control' maxLength={80} />
                                    <ErrorMessage name="afflOrderProcNo202021" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='field-mandatory mb-1'>Affiliation Order {acYear} being approved by </label>
                                    <Field as="select" name="authorityBy" className="form-control" style={{ paddingRight: '30px' }}>
                                        <option value="">--Select--</option>
                                        <option value="REGISTRAR">REGISTRAR</option>
                                        <option value="VICE-CHANCELLOR">VICE-CHANCELLOR</option>
                                    </Field>
                                    <ErrorMessage name="authorityBy" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='field-mandatory mb-1'>Date of Affiliation Order {acYear}:</label>
                                    <Field type='date' name="afflOrder202223Date" className='form-control'
                                        value={new Date().toISOString().split('T')[0]}
                                        readOnly
                                        onKeyDown={(e) => { e.preventDefault() }} />
                                    <ErrorMessage name="afflOrder202223Date" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='field-mandatory mb-1'>Proceedings Number of Affiliation Order {acYear}: </label>
                                    <Field type='text' name="afflOrderProcNo202223" className='form-control' maxLength={80} />

                                    <ErrorMessage name="afflOrderProcNo202223" component="div" className="text-error" />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='field-mandatory mb-1'> Registrar Remarks: </label>
                                    <Field as='select' name="registrarRemarks" className='form-control mb-2'>
                                        <option value="">--Select--</option>
                                        <option value="Temporary Affiliation">Temporary Affiliation</option>
                                        <option value="Permanent Affiliation">Permanent Affiliation</option>
                                        <option value="Conditional Affiliation">Conditional Affiliation</option>

                                    </Field>
                                    <ErrorMessage name="registrarRemarks" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3} className='mb-2'>
                                    <label className='mb-1' >Remarks: </label>
                                    <Field as='textarea' name="remarks" className='form-control mb-2' />
                                </bie.Col>
                            </bie.Row>
                            <bie.Row>
                                <div className="d-flex flex-row justify-content-end">
                                    {hidepdf === false ? (<>
                                        <button type="submit" className="btn btn-success btn-sm " >
                                            Submit
                                        </button> &emsp;

                                    </>) : (<>
                                        <button type="button" className="btn btn-primary btn-sm" onClick={() => { showViewPDF(config.url.FILE_DOWNLOAD_URL + viewpdf); }}
                                        // onClick={GeneratePDF}

                                        >View Pdf</button> &emsp;
                                    </>)}


                                </div>
                            </bie.Row>
                        </bie.Row>


                        <bie.Modal show={modal} onHide={handleClose} size="xl" backdrop="static">
                            <bie.Modal.Header style={{ backgroundColor: '#6f7cc3' }} className="text-white">
                                <bie.Modal.Title style={{ textAlign: "center", width: "100%" }}> PDF View</bie.Modal.Title>
                            </bie.Modal.Header>
                            <bie.Modal.Body style={{ width: '100%', padding: 0 }}>
                                {pdfUrl && (
                                    <embed
                                        src={pdfUrl}
                                        type="application/pdf"
                                        width="100%"
                                        height="800px"
                                    />
                                )}
                            </bie.Modal.Body>
                            <bie.Modal.Footer>
                                <bie.Button variant="secondary" onClick={handleClose}>Close</bie.Button>
                                <bie.Button variant="primary" onClick={dskConfirmationFunc}>Digtal Signature</bie.Button>
                            </bie.Modal.Footer>
                        </bie.Modal>
                    </Form>
                </FormikProvider>
            </bie.Container >

        </>
    )
}
